export default class SolutionsFilter {
	constructor() {
		document.querySelectorAll('[data-solutions-filter]').forEach((nav) => {
			const list = document.querySelector('[data-solutions-filter-list]');
			if (!list) {
				return;
			}

			const items = list.querySelectorAll('[data-solution-type]');
			const buttons = nav.querySelectorAll('[data-solutions-filter-value]');

			buttons.forEach((button) => {
				button.addEventListener('click', () => {
					const value = button.dataset.solutionsFilterValue;

					buttons.forEach((btn) => btn.classList.toggle('active', btn === button));

					items.forEach((item) => {
						const match = value === 'all' || item.dataset.solutionType === value;
						item.classList.toggle('d-none', !match);
					});
				});
			});
		});
	}
}
